module.exports = __webpack_public_path__ + "h5/img/xmjs.9f1dbf5e.jpg";